import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ColaboradorEncuestaervice } from './colaboradores-encuesta.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_encuesta35 } from 'app/idiomas/i18n/encuesta35/encuesta35.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import * as backInter from 'app/auth/auth-data.model';
import { Subject } from 'rxjs';
import * as colabInter from './colaboradores-encuesta.interface';
import {MatTableDataSource} from '@angular/material/table';
import Swal from 'sweetalert2';
export interface getBD_COL{
  message: string,
  colaboradores: Colaborador[]
}
export interface Colaborador {
  anio_nacimiento: string,
  area: string,
  celular: string,
  centroId: string,
  clave: string,
  clave_jefe: string,
  correo: string,
  createdAt: string,
  empresa: string,
  id_CT: number,
  nombre: string,
  productoId: string,
  telefono: string,
  updatedAt: string,
  usuario_creado: boolean,
  _id: string,
}

@Component({
  selector: 'app-colaboradores-encuesta',
  templateUrl: './colaboradores-encuesta.component.html',
  styleUrls: ['./colaboradores-encuesta.component.scss'],
  animations   : fuseAnimations
})


export class ColaboradoresEncuestaComponent implements OnInit {
  displayedColumns: string[] = ['name', 'tel', 'correo', 'clave'];
  dataSource: MatTableDataSource<getBD_COL>;
  productoCertificar: backInter.prodNorma35;
  productoCertificar_CT: backInter.prodNorma35;
  LevelUser35:any;
  centrosTrabajo: any;
  Nivel1:boolean;
  info_hijosct:any ;
  Id_cthijo: any;
  Idmongo_cthijo: any;
  listaColaboradores_tmp: any [] = [];
  empresaPadre_tmp:any;
  resultados_url: any [] = [];
  cargandoInformacion=true;
  encontro_informacion:boolean=true;
  info_padre:any;

  colaboradoresListTmp:any;
  urlAutoLogin:any;
  centroId_tmp:any;
  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private EncuestaColabl_Service: ColaboradorEncuestaervice,
  ) {
    lang_encuesta35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.LevelUser35 = localStorage.getItem('levelUser_tmp');

    console.log("Nivel de usuario "+this.LevelUser35);
    if(this.LevelUser35 == '1'){
      this.Nivel1=true;
      this.info_padre=this.colaboradoresService.getinfo();
      //console.log("Información padre");
      //console.log(this.info_padre);

    }else{
      this.Nivel1=false;
      this.info_hijosct=this.colaboradoresService.getinfo();
      localStorage.setItem('producto_padreTmp',''+this.info_hijosct.productoId);
      this.Id_cthijo = this.info_hijosct.id_CT;
      console.log("Información hijo");
      console.log(this.info_hijosct);

    }

   }

  ngOnInit() {
    this.obtieneCertificarActual();

  }

  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              // CARGA DE LISTA DE CENTROS DE TRABAJO
              console.log("Producto");
              console.log(this.productoCertificar);
              this.EncuestaColabl_Service.getInfoCentros(this.productoCertificar.fechaNorma35).subscribe( (resu:backInter.getInfoCentros) => {
                this.centrosTrabajo = resu.centros;
                // OBTENER EL ID DE MONGO DEL CENTRO DE TRABAJO DONDE SE INICIO SESIÓN
                if(localStorage.getItem('levelUser_tmp') == '6'){

                  for(let j=0; j < this.centrosTrabajo.length; j++){
                    if(this.Id_cthijo == this.centrosTrabajo[j].centro.id_CT){
                      this.Idmongo_cthijo=this.centrosTrabajo[j].centro._id;
                    }

                  }

                }
                // FIN
                this.getCentros_url();
                this.getcolaboradores_encuesta();
              });



              //FIN CARGA LISTA DE CENTROS
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getcolaboradores_encuesta(){
      this.EncuestaColabl_Service.getColaboradores_encuesta(this.productoCertificar.idNorma35).subscribe( (resu:colabInter.getBD_COL) => {
      this.colaboradoresListTmp=resu.colaboradores;
      this.dataSource = new MatTableDataSource(this.colaboradoresListTmp);
      this.dataSource.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          return key === 'doctores' ? currentTerm : currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };
      //this.dataSource.paginator = this.paginator;
      if(this.LevelUser35 == '6'){
        this.filtroCT(this.Id_cthijo);
        this.urlAutoLogin='home?empresa='+localStorage.getItem('idPadre_temporal')+'&pod='+localStorage.getItem('producto_padreTmp')+'&centro='+this.Idmongo_cthijo+'&idct='+this.Id_cthijo;
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sinInformacion_hijos:boolean=false;
  liga_ct:any;
  nombreCT_tpm:any;
  carga_filtro:boolean=false;
  filtroCT(IdCt,idmongo?:any,nombreCT?:any){
    //this.Nivel1=false;
    this.carga_filtro=false;
    console.log("IDct "+IdCt);
    console.log("Id mongo "+idmongo);
    console.log("nombre ct "+nombreCT);
    this.listaColaboradores_tmp=[];
    this.nombreCT_tpm=nombreCT;
    this.EncuestaColabl_Service.getColaboradores_encuesta(this.productoCertificar.idNorma35).subscribe( (resu:colabInter.getBD_COL) => {
      //console.log("Resultados");
      //console.log(resu);
      this.colaboradoresListTmp=resu.colaboradores;
      for(let i=0; i<this.colaboradoresListTmp.length;i++ ){
        if(this.colaboradoresListTmp[i].id_CT == IdCt){
          this.listaColaboradores_tmp.push(this.colaboradoresListTmp[i]);
        }
      }
      this.colaboradoresListTmp=this.listaColaboradores_tmp;
      if(this.colaboradoresListTmp.length == 0){
        this.encontro_informacion=false;
      }else{
        this.encontro_informacion=true;
      }
      if(this.LevelUser35 == '1'){
        this.liga_ct="http://localhost:4200/home?empresa="+this.info_padre.empresaId+"&pod="+this.productoCertificar.idNorma35+"&centro="+idmongo+"&idct="+IdCt;
      }

      //http://localhost:4200/home?empresa=5ecfcc455fec483f8d3f8be9&pod=5ede584b6da1ee7a934cd554&centro=5ede60666da1ee7a934cda79&idct=1
      this.dataSource = new MatTableDataSource(this.colaboradoresListTmp);
      this.dataSource.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          return key === 'doctores' ? currentTerm : currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };
      this.carga_filtro=true;
    });
  }
  urlCorta:any;
  getCentros_url(id_ct?:any){

    this.EncuestaColabl_Service.getColaboradores_url(this.productoCertificar.idNorma35).subscribe( (resultado:colabInter.get_CTacortadores) => {
      this.resultados_url=resultado.urlCentros;
      console.log(this.resultados_url);
      if(localStorage.getItem('levelUser_tmp') == '6'){
        let envio=0;
        for (let i=0; i <this.resultados_url.length; i++){
          if(this.Idmongo_cthijo == this.resultados_url[i].centroId){
            this.urlCorta=this.resultados_url[i].urlCorta;
            console.log("Url corta");
            console.log(this.urlCorta);
            envio++;
          }
        }
        if(envio==0){
          console.log("Va a crear las urls");
          this.sendCentros_url(this.Idmongo_cthijo,this.Id_cthijo);
        }else{
          console.log("No Va a crear las urls");
          this.cargandoInformacion=false;
        }
      }else{
        this.cargandoInformacion=false;
      }
    },error=>{
      console.log(error);
    });
  }

  sendCentros_url(idCt:any, idExcel:any){
    this.EncuestaColabl_Service.sendColaboradores_url(this.productoCertificar.idNorma35,idCt,idExcel).subscribe( (resultado:any) => {
      console.log(resultado);
      /*for (let i=0; i <this.resultados_url.length; i++){
        if(this.Idmongo_cthijo == this.resultados_url[i].centroId){
          this.urlCorta=this.resultados_url[i].urlCorta;
          console.log("Url corta");
          console.log(this.urlCorta);
        }
      }*/

      this.cargandoInformacion=false;
    },error=>{
      console.log(error);
    });
  }

  copyMessage(){
    let textoResp= 'WIZARD.COPY';
    this.translateSrv.get(textoResp).subscribe((res: string) => { textoResp = res; });
    console.log("Translate "+textoResp);
    Swal.fire({
      icon: 'success',
      title: textoResp,

    });

    /*let texto = 'CIERRE.CIERRE.COPYLINK';
    console.log("Copiar");
    console.log(this.claves[val]);
    */

    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    //this.rutaPagina = DATOS_API.urlConteos + val;
    //this.rutaPagina=this.liga_ct;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.liga_ct;
    console.log(this.liga_ct);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }


}
